import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import DashboardIndex from "../../../components/SidetabPages/Dashboard/DashboardIndex";

const Dashboard = () => {
  return (
    <>
      <AnnouncementBar />
      <DashboardIndex />
    </>
  );
};
export default Dashboard;
